

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from '../auth.guard';
import { AppointmentConfigurationComponent } from './appointment-management/appointment-configuration/appointment-configuration.component';
import { AppointmentManagementListComponent } from './appointment-management/appointment-management-list/appointment-management-list.component';
import { AppointmentBookingConfirmationComponent } from './appointment-management/appointment-booking-confirmation/appointment-booking-confirmation.component';

const routes: Routes = [
  { path: '', redirectTo: 'appointments', pathMatch: 'full' },
  { path: 'configuration', canActivate: [AuthGuardService], component: AppointmentConfigurationComponent },
  { path: 'appointments', canActivate: [AuthGuardService], component: AppointmentManagementListComponent },
  { path: 'booking-confirmation', component: AppointmentBookingConfirmationComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [AuthGuardService]
})
export class AppRoutingModule { }
